var quantityMixin = {
    data: function () {
        return {
            inStock: true,
            product: {
                quantity: 1
            },
            debouncedUpdateTextQuantityPrice: null
        }
    },
    created() {
        this.debouncedUpdateTextQuantityPrice = _.debounce(this.updateProductPrice, 1000);
    },
    methods: {
        addQuantity: function () {
            vueProduct.product.quantity++;

            this.debouncedUpdateTextQuantityPrice();
        },
        subtractQuantity: function () {
            if (vueProduct.product.quantity > 1)
                vueProduct.product.quantity--;

            this.debouncedUpdateTextQuantityPrice();
        }
    },
    watch: {
        "product.quantity": function () {
            this.showFromPrice = false;
            this.debouncedUpdateTextQuantityPrice();
        }
    }
}